import clsx from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';
import { dateFormat } from '@/utils/dateFormat';

type Props = {
  title?: string;
  isOpen: boolean;
  dateRange?: { start?: Date; end?: Date };
} & ComponentPropsWithoutRef<'button'>;

export default function CalendarRangeDropdownButton({
  isOpen,
  dateRange = undefined,
  ...props
}: Props) {
  return (
    <button
      type="button"
      className={clsx(
        'flex h-[42px] w-full appearance-none items-center justify-around rounded border border-solid border-border px-2',
        isOpen && 'border-2! border-solid! border-primary!'
      )}
      {...props}
    >
      <span className="text-sm">
        {dateRange?.start === undefined && dateRange?.end === undefined
          ? 'すべて'
          : `${dateRange.start ? dateFormat(dateRange.start) : ''} ~ ${dateRange.end ? dateFormat(dateRange.end) : ''}`}
      </span>
      <img
        className="ml-auto"
        src={`/agent/job_change_processes/icon-calendar.svg`}
        width={24}
        height={24}
        alt=""
      />
    </button>
  );
}
